module.exports = __webpack_public_path__ + "img/TENNIS_COURT.1cfecbfe.svg";